import { validateTour, type Station } from '@/content/schema';
import { tour as rawTour } from '@/content/tour';
import { create } from 'zustand';

export const tour = validateTour(rawTour);
export const stations: readonly Station[] = tour.stations;

const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const heroKey = params?.get('hero');
export const hero = (heroKey && tour.heroes[heroKey]) || tour.hero;

export function stationIndexAt(progress: number): number {
  let idx = 0;
  for (let i = 0; i < stations.length; i++) {
    const first = stations[i]!.waypoints[0]!.at;
    if (progress + 1e-6 >= first) idx = i;
  }
  return idx;
}

export interface HoveredElement {
  layer: string;
  expressID: number;
  type: string;
  name: string;
  x: number;
  y: number;
}

interface TourState {
  progress: number;
  activeIndex: number;
  hovered: HoveredElement | null;
  reducedMotion: boolean;
  dev: boolean;
  ready: boolean;
  backend: 'WebGPU' | 'WebGL 2' | null;
  setProgress: (p: number) => void;
  setHovered: (h: HoveredElement | null) => void;
  setReady: (r: boolean) => void;
  setBackend: (b: 'WebGPU' | 'WebGL 2') => void;
}

const prefersReduced =
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const useTourStore = create<TourState>((set) => ({
  progress: 0,
  activeIndex: 0,
  hovered: null,
  reducedMotion: prefersReduced,
  dev: params?.has('dev') ?? false,
  ready: false,
  backend: null,
  setProgress: (p) => {
    const progress = Math.min(1, Math.max(0, p));
    set({ progress, activeIndex: stationIndexAt(progress) });
  },
  setHovered: (hovered) =>
    set((s) =>
      s.hovered === hovered ||
      (s.hovered &&
        hovered &&
        s.hovered.expressID === hovered.expressID &&
        s.hovered.x === hovered.x)
        ? s
        : { hovered },
    ),
  setReady: (ready) => set({ ready }),
  setBackend: (backend) => set({ backend }),
}));
